import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "admin-section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  target: "_blank",
  href: "https://regex101.com/"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_NcTextField = _resolveComponent("NcTextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    (_ctx.status)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_NcNoteCard, {
            type: _ctx.status.indexed_count > 0 ? 'success' : 'warning'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('memories', '{n} media files have been indexed', { n: _ctx.status.indexed_count })), 1)
            ]),
            _: 1
          }, 8, ["type"]),
          (_ctx.status.failure_count > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_NcNoteCard, { type: "warning" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', '{n} media files failed indexing and were skipped.', { n: _ctx.status.failure_count })) + " ", 1),
                    _createElementVNode("a", {
                      href: _ctx.API.FAILURE_LOGS(),
                      target: "_blank"
                    }, _toDisplayString(_ctx.t('memories', 'View failure logs.')), 9, _hoisted_3)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Files that failed indexing will not be indexed again unless they change.')) + " " + _toDisplayString(_ctx.t('memories', 'You can manually retry files that failed indexing.')) + " ", 1),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                _cache[12] || (_cache[12] = _createElementVNode("code", null, "occ memories:index --retry", -1))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_NcNoteCard, {
            type: _ctx.status.last_index_job_status_type
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('memories', 'Automatic Indexing status: {status}', { status: _ctx.status.last_index_job_status })), 1)
            ]),
            _: 1
          }, 8, ["type"]),
          (_ctx.status.last_index_job_start)
            ? (_openBlock(), _createBlock(_component_NcNoteCard, {
                key: 1,
                type: _ctx.status.last_index_job_duration ? 'success' : 'warning'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Last index job was run {t} seconds ago.', { t: _ctx.status.last_index_job_start })) + " " + _toDisplayString(_ctx.status.last_index_job_duration
            ? _ctx.t('memories', 'It took {t} seconds to complete.', { t: _ctx.status.last_index_job_duration })
            : _ctx.t('memories', 'It is still running or was interrupted.')), 1)
                ]),
                _: 1
              }, 8, ["type"]))
            : _createCommentVNode("", true),
          (_ctx.status.last_index_job_start > 3600)
            ? (_openBlock(), _createBlock(_component_NcNoteCard, {
                key: 2,
                type: "error"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t(
            'memories',
            'Looks like it has been more than an hour since the last index job was run. Make sure Nextcloud cron is configured correctly.',
          )), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.status.bad_encryption)
            ? (_openBlock(), _createBlock(_component_NcNoteCard, {
                key: 3,
                type: "error"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t(
            'memories',
            'Only server-side encryption (OC_DEFAULT_MODULE) is supported, but another encryption module is enabled.',
          )), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.t(
          'memories',
          'The EXIF indexes are built and checked in a periodic background task. Be careful when selecting anything other than automatic indexing. For example, setting the indexing to only timeline folders may cause delays before media becomes available to users, since the user configures the timeline only after logging in.',
        )) + " ", 1),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        modelValue: _ctx.config['memories.index.mode'],
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config['memories.index.mode']) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('memories.index.mode')))
        ],
        value: "1",
        name: "idxm_radio",
        type: "radio"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Index all media automatically (recommended)')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        modelValue: _ctx.config['memories.index.mode'],
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config['memories.index.mode']) = $event)),
          _cache[3] || (_cache[3] = ($event: any) => (_ctx.update('memories.index.mode')))
        ],
        value: "2",
        name: "idxm_radio",
        type: "radio"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Index per-user timeline folders (not recommended)')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        modelValue: _ctx.config['memories.index.mode'],
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config['memories.index.mode']) = $event)),
          _cache[5] || (_cache[5] = ($event: any) => (_ctx.update('memories.index.mode')))
        ],
        value: "3",
        name: "idxm_radio",
        type: "radio"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Index a fixed relative path')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        modelValue: _ctx.config['memories.index.mode'],
        "onUpdate:modelValue": [
          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.config['memories.index.mode']) = $event)),
          _cache[7] || (_cache[7] = ($event: any) => (_ctx.update('memories.index.mode')))
        ],
        value: "0",
        name: "idxm_radio",
        type: "radio"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Disable background indexing')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.config['memories.index.mode'] === '3')
        ? (_openBlock(), _createBlock(_component_NcTextField, {
            key: 0,
            label: _ctx.t('memories', 'Indexing path (relative, all users)'),
            "label-visible": true,
            "model-value": _ctx.config['memories.index.path'],
            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.update('memories.index.path', $event.target.value)))
          }, null, 8, ["label", "model-value"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.t('memories', 'Folders with a ".nomedia" or a ".nomemories" file are always excluded from indexing.')) + " " + _toDisplayString(_ctx.t('memories', 'You can optionally use a regular expression to exclude matching paths from being indexed.')) + " " + _toDisplayString(_ctx.t('memories', 'For example, to exclude special QNAP folders:')) + " ", 1),
      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
      _cache[14] || (_cache[14] = _createElementVNode("code", null, "\\/@(Recycle|eaDir)\\/", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Or, exclude all files starting with "private-" or "backup-":')) + " ", 1),
      _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
      _cache[17] || (_cache[17] = _createElementVNode("code", null, "\\/(private|backup)-[^\\/]*$", -1)),
      _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'You can use the regex101 website to validate and test the pattern:')) + " ", 1),
      _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.t('memories', 'External Link')), 1),
      _createVNode(_component_NcTextField, {
        class: "regex-field",
        label: _ctx.t('memories', 'Exclude paths matching regular expression'),
        "label-visible": true,
        modelValue: _ctx.config['memories.index.path.blacklist'],
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.config['memories.index.path.blacklist']) = $event)),
        error: !_ctx.blacklistRegexValid,
        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.blacklistRegexValid && _ctx.update('memories.index.path.blacklist', $event.target.value)))
      }, null, 8, ["label", "modelValue", "error"])
    ]),
    _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.t('memories', 'For advanced usage, perform a run of indexing by running:')) + " ", 1),
      _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
      _cache[20] || (_cache[20] = _createElementVNode("code", null, "occ memories:index", -1)),
      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Run index in parallel with 4 threads:')) + " ", 1),
      _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
      _cache[23] || (_cache[23] = _createElementVNode("code", null, "bash -c 'for i in {1..4}; do (occ memories:index &); done'", -1)),
      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Force re-indexing of all files:')) + " ", 1),
      _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
      _cache[26] || (_cache[26] = _createElementVNode("code", null, "occ memories:index --force", -1)),
      _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'You can limit indexing by user and/or folder:')) + " ", 1),
      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
      _cache[29] || (_cache[29] = _createElementVNode("code", null, "occ memories:index --user=admin --path=/Photos/", -1)),
      _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Clear all existing index tables:')) + " ", 1),
      _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
      _cache[32] || (_cache[32] = _createElementVNode("code", null, "occ memories:index --clear", -1))
    ])
  ]))
}